import * as yup from 'yup';

export const addClaimantValidation = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
    country: yup.string().required(),
    state: yup.string().required(),
    phone: yup.string().required(),
});

export const addDisclaimantValidation = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email().required(),
    phone: yup.string().required(),
});

const caseFactsValidation = yup.object().shape({
    industry: yup.string().optional(),
    description: yup.string().required(),
    reliefs: yup.string().required(),
})


export const creatCaseValidation = yup.object().shape({
    facts: caseFactsValidation,
    claimants: yup.array().of(addClaimantValidation).required(),
    defendants: yup.array().of(addDisclaimantValidation).required(),
    monetaryClaim: yup.string().default(0),
    banta: yup.string().default(0),
})
